import { SET_IDV_RETURN_PARAM, SET_IDV_STATUS } from "stash/actions";
import { idvFraudScreenStatus, idvScreenNames, idvVerificationAction } from "stash/constants/identityVerification";

export const getNextScreen = (idvStatus) => {
  const status = idvStatus?.fraudScreen?.status;
  const action = idvStatus?.verification?.action;

  switch(true) {
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_VERIFIED: {
      return idvScreenNames.CELEBRATION;
    }
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_DENIED: {
      return idvScreenNames.HARD_FAIL;
    }
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_WAITING_ROOM && action === idvVerificationAction.VERIFICATION_ACTION_REVIEW_PII: {
      return idvScreenNames.IDV_FLOW;
    }
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_WAITING_ROOM && action === idvVerificationAction.VERIFICATION_ACTION_REVIEW_DOCUMENTS: {
      return idvScreenNames.DOC_UPLOAD;
    }
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_WAITING_ROOM && action === idvVerificationAction.VERIFICATION_ACTION_NONE: {
      return idvScreenNames.MANUAL_REVIEW;
    }
    case status === idvFraudScreenStatus.FRAUD_SCREEN_STATUS_NOT_VERIFIED: { // Retry polling scenario
      return idvScreenNames.CHECK_LOADER;
    }
    case status === idvFraudScreenStatus.ERROR: {
      return idvScreenNames.ALLOY_OUTAGE;
    }
    default: {
      return idvScreenNames.GENERIC_ERROR;
    }
  }
}

const idvStatus = (state={}, action) => {
  switch (action.type) {
    case SET_IDV_STATUS: {
      return {
        ...state,
        screenStatus: action.value,
        nextScreen: getNextScreen(action.value),
      }
    }
    case SET_IDV_RETURN_PARAM: {
      return {
        ...state,
        isReturnedFromIDVFlow: action.value || false,
      }
    }
    default:
      return state;
  }
};

export default idvStatus;
